module.exports = __webpack_public_path__ + "static/img/06.17_LNHCapabilities_Mobile.1ee93e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/06.17_LNHCapabilities_Mobile.svg
// module id = vAXm
// module chunks = 1